export const CHECKOUT_DEFAULT_THEME = 'checkout-default';
export const CHECKOUT_OPTIMISATION_THEME = 'checkout-optimisation';
